export default function ({ link }) {
    return (
        <>
            <h3 className="text-lg leading-6 font-medium text-black">
                Oglas je uspješno deaktiviran!
            </h3>
            <div className="mt-2 px-7 py-3">
                <p className="text-sm text-gray-dark">
                    Deaktivacija oglasa će se desiti u narednih 10 minuta.
                </p>
            </div>
            <div className="items-center px-4 py-3">
                <a
                    href={link}
                    className="px-4 py-2 border-gray border text-base font-medium rounded-md w-full mb-3 shadow-sm focus:outline-none focus:ring-2 hover:bg-gray-light"
                >
                    Idi nazad na kompaniju
                </a>
            </div>
        </>
    );
}
